import { render, staticRenderFns } from "./UserBidList.vue?vue&type=template&id=1955d00e&"
import script from "./UserBidList.vue?vue&type=script&lang=js&"
export * from "./UserBidList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports